// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { BoostedSportsByCategories } from '../../constants/boostedOdds';
import { CARD_BADGE_HEIGHT, CARD_BADGE_WIDTH } from '../../constants/ui/cardBadge';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import FlagIcon from '../FlagIcon';
import SportIcon from '../SportIcon';

const CardBadgeWrapper = styled.div`
  position: relative;
  height: ${CARD_BADGE_HEIGHT}em;
  width: ${CARD_BADGE_WIDTH}em;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ $hasAttach }) => {
    if ($hasAttach) {
      return css`
        &:before {
          position: absolute;
          content: '';
          left: 0;
          top: 100%;

          width: 0;
          height: 0;
          border-left: 0.44em solid transparent;
          border-top: 1.31em solid ${theme.MatchCardHeaderBadge.Delimiter.backgroundColor};
        }
      `;
    }
  }}

  ${({ $sportId, $flagId }) => {
    if ($sportId) {
      return css`
        width: ${CARD_BADGE_WIDTH * 1.75}em;
      `;
    }

    if ($flagId) {
      return css`
        width: ${CARD_BADGE_WIDTH * 1.45}em;
      `;
    }
  }}
`;

export const MainCardBadgeClassName = 'main-card-badge';
const Main = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  border-radius: 1.2em 0;
  box-shadow: 0.12em 0.12em 0.4em 0 rgba(0, 0, 0, 0.8);
  background-color: ${theme.MatchCardHeaderBadge.mainBackgroundColor};
  overflow: hidden;
`;

const Secondary = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: space-evenly;
  align-items: center;

  border-radius: inherit;
  background-color: transparent;
  z-index: inherit;
`;

const StyledSportIcon = styled(SportIcon)`
  width: 2.45em;
  height: 2.45em;
`;

const StyledFlagIcon = styled(FlagIcon)`
  width: 1.5em;
  height: 1.5em;
  border-radius: 0.3em;
  margin-left: -0.4em;
`;

const LIVE_BADGE_WIDTH = 77;
const LiveBadgeTranslateYRatio = 90;

const LiveBadge = styled.div`
  position: absolute;
  top: ${LiveBadgeTranslateYRatio}%;
  left: ${(100 - LIVE_BADGE_WIDTH) / 2}%;
  transform: translateY(-${LiveBadgeTranslateYRatio}%);
  opacity: 0;
  width: ${LIVE_BADGE_WIDTH}%;
  max-width: 2.8em;
  height: 70%;

  border-bottom-left-radius: 0.3em;
  border-bottom-right-radius: 0.3em;

  display: flex;
  align-items: flex-end;
  justify-content: center;

  font-weight: bold;
  text-transform: uppercase;

  background-color: ${theme.MatchCardHeaderBadge.liveBackgroundColor};
  color: ${theme.MatchCardHeaderBadge.liveColor};

  transition: all 200ms ease-in-out;
  ${({ $show }) => {
    if ($show) {
      return css`
        transform: translateY(0%);
        opacity: 1;
      `;
    }
  }};
`;

const LiveBadgeLabel = styled.span`
  font-size: 0.9em;
`;

type MatchCardHeaderBadgeProps = {
  className?: string;
  sportId: number;
  categoryId: number;
  isLive?: boolean;
  hasAttach?: boolean;
  flagId?: string;
  isMultimatch?: boolean;
};

const MatchCardHeaderBadge = ({
  className,
  sportId,
  categoryId,
  isLive = false,
  hasAttach = true,
  flagId,
  isMultimatch,
}: MatchCardHeaderBadgeProps) => {
  return (
    <CardBadgeWrapper
      className={`${className || ''} badgeWrapper`}
      $hasAttach={hasAttach}
      $sportId={BoostedSportsByCategories[categoryId]}
      $flagId={flagId}
    >
      <LiveBadge $show={isLive}>
        <LiveBadgeLabel>{__('In Play')}</LiveBadgeLabel>
      </LiveBadge>
      <Main className={`badge ${MainCardBadgeClassName}`}>
        <Secondary>
          <StyledSportIcon className="boostedIcon" sportId={sportId} isMultimatch={isMultimatch} />
          {BoostedSportsByCategories[categoryId] ? (
            <StyledSportIcon sportId={BoostedSportsByCategories[categoryId]} />
          ) : null}
          {flagId ? <StyledFlagIcon flagId={flagId} /> : null}
        </Secondary>
      </Main>
    </CardBadgeWrapper>
  );
};

export default MatchCardHeaderBadge;
